export const getProppedValue = (value) =>
  typeof value === "object" ? value?.props?.children : value;
